<div class="dialog-container">
  <div class="dialog-header">
    @if (agreement) {
      <div class="header-start">
        <h2 class="title">{{ agreement.key }}</h2>
      </div>
    }

    <p-button text icon="pi pi-times" rounded styleClass="color--primary" (onClick)="close()">
    </p-button>
  </div>

  <div class="dialog-content">
    @if (agreement) {
      <div class="dialog__agreement-text">
        <div
          [innerHTML]="agreement.text"
          dataAttribute
          class="dialog__agreement-scroll"
          componentName="agreement-text"
        ></div>
      </div>
    }
  </div>

  <div class="dialog-footer">
    <div class="action-buttons btn-container">
      <p-button
        fluid
        severity="secondary"
        class="consent-close-btn"
        [label]="'COMMON.CLOSE' | transloco"
        (onClick)="close()"
      ></p-button>

      <p-button
        [label]="'COMMON.SAVE' | transloco"
        fluid
        severity="primary"
        class="consent-accept-btn"
        (onClick)="accept()"
      ></p-button>
    </div>
  </div>
</div>
